// extracted by mini-css-extract-plugin
export default {"newEntryContainer":"NewEntrySection_newEntryContainer__yBQ+4","newEntryHeader":"NewEntrySection_newEntryHeader__KTGPk","headerContent":"NewEntrySection_headerContent__5C9rB"};